import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("path", {
            fill: "#252729",
            d: "M12.15 2c4.453.112 8.037 3.696 8.149 8.148-.082 1.322-.451 2.606-1.082 3.766h-.001v.001l-.062.107c-.05.089-1.163 1.885-2.465 3.686-2.479 3.486-3.536 4.188-4.54 4.191-.316.002-.863-.008-1.921-.994-1.061-.986-2.652-2.951-5.101-6.877l-.001-.002-.064-.112c-.624-1.161-.988-2.446-1.062-3.762.111-4.456 3.695-8.04 8.147-8.152zm-.001 1.45c-1.851 0-3.525.75-4.738 1.962-1.212 1.213-1.962 2.886-1.962 4.736.069 1.095.374 2.161.893 3.127.009.014.636 1.017 1.494 2.274.861 1.265 1.952 2.784 2.867 3.792.605.674 1.148 1.116 1.446 1.11.454.012 1.425-.995 2.405-2.26.988-1.264 2.015-2.782 2.679-3.794.339-.516.579-.894.676-1.048h-.007l.04-.073c.523-.965.833-2.032.906-3.128 0-1.85-.75-3.523-1.962-4.736C15.674 4.2 14 3.45 12.149 3.45zm0 2.599c2.016 0 3.65 1.635 3.65 3.651 0 2.015-1.634 3.649-3.65 3.649-2.017 0-3.65-1.634-3.65-3.649 0-2.016 1.633-3.651 3.65-3.651zm0 1.451c-1.216.003-2.198.985-2.2 2.2.002 1.215.984 2.198 2.2 2.2 1.215-.002 2.197-.985 2.2-2.2-.003-1.215-.985-2.197-2.2-2.2z",
            transform: "translate(-20 -458) translate(20 458)"
          })
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }